/**
 * Feedback tátil/sonoro da leitura por câmera — na doca o operador mira o volume, não olha os
 * números, então precisa "sentir" cada leitura. Tudo é feature-detectado e embrulhado em
 * try/catch: sem AudioContext (jsdom) ou sem `navigator.vibrate` (desktop), vira no-op silencioso
 * em vez de quebrar o scan.
 */

// Reaproveita um único AudioContext — criar um por bipe estoura o limite do browser.
let ctx: (AudioContext | null) = null;

type ContextCtor = typeof AudioContext;

function contexto(): AudioContext | null {
  try {
    if (ctx) return ctx;
    const Ctor: ContextCtor | undefined =
      window.AudioContext ?? (window as unknown as { webkitAudioContext?: ContextCtor }).webkitAudioContext;
    if (!Ctor) return null;
    ctx = new Ctor();
    return ctx;
  } catch {
    return null;
  }
}

function bip(frequencia: number, duracaoMs: number): void {
  const ac = contexto();
  if (!ac) return;
  try {
    // Alguns browsers suspendem o AudioContext até um gesto do usuário; ligar a câmera É o gesto,
    // mas resume() por garantia (no-op se já ativo).
    if (ac.state === 'suspended') void ac.resume();
    const osc = ac.createOscillator();
    const gain = ac.createGain();
    osc.type = 'square';
    osc.frequency.value = frequencia;
    gain.gain.value = 0.12; // discreto — não estridente num galpão silencioso
    osc.connect(gain);
    gain.connect(ac.destination);
    osc.start();
    osc.stop(ac.currentTime + duracaoMs / 1000);
  } catch {
    /* áudio indisponível — segue sem som */
  }
}

function vibrar(padrao: number | number[]): void {
  try {
    navigator.vibrate?.(padrao);
  } catch {
    /* sem vibração — ok */
  }
}

/**
 * Destrava o áudio DENTRO de um gesto do usuário (o clique no botão de câmera). No iOS Safari
 * o WebAudio só sai do estado `suspended` se o `resume()` acontecer durante um gesto — criar o
 * contexto no primeiro bipe (dentro do callback do decode, fora de gesto) deixaria os primeiros
 * bips mudos no iPad. Chamar isto no onClick do toggle resolve. No-op silencioso sem WebAudio.
 */
export function prepararAudio(): void {
  const ac = contexto();
  if (ac && ac.state === 'suspended') {
    try { void ac.resume(); } catch { /* sem áudio — ok */ }
  }
}

/** Leitura casou com um item da nota: bip curto e agudo + vibração breve. */
export function feedbackSucesso(): void {
  bip(880, 90);
  vibrar(60);
}

/** Código não pertence a esta nota (ou não cadastrado): bip grave + vibração dupla de alerta. */
export function feedbackErro(): void {
  bip(280, 200);
  vibrar([50, 60, 50]);
}
